
export class ApiCallFailure {

    connectionSuccessful: boolean = false
    responseCode?: number
    errorType?: string
    message?: string

}